import styled from 'styled-components';

export const EarningsRevenueTableWrapper = styled('div')`
  height: 292px;
`;
